import Vue from 'vue'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import VueMoment from 'vue-moment'

Vue.filter('niceDate', (date) => {
  return moment(date).format('D MMMM YYYY')
})

Vue.filter('gmapStaticQuery', (coordinates) => {
	let str = "";

	coordinates.forEach((cord) => {
		str += `C${cord.lat},${cord.lng}%7`;

	})

	str = str.slice(0, -1);
	return str;
})

Vue.filter('camelToNormal', (camelCased) => {
	

    // insert a space before all caps, // uppercase the first character
	return camelCased
	.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function(str){ return str.toUpperCase(); })
	
})

Vue.filter('exVAT', (cost) => {

	return cost/1.2;
	
})

Vue.filter('VAT', (cost) => {

	return cost-(cost/1.2);
	
})

Vue.filter('truncate', function(str, length, ellipses) {
	length = length || 30;

	if (str.length <= length) {
		return str;
	}

	if (ellipses === undefined) {
		ellipses = '...';
	}
	ellipses = '' + ellipses;

	str = str.slice(0, length);

	return str + ellipses;
});

// some nice filters


Vue.use(Vue2Filters)
Vue.use(VueMoment);

export default Vue;


// WEBPACK FOOTER //
// ./src/filters/index.js